import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import downarrow from "../../../assets/downarrow.png";
import uparrow from "../../../assets/uparrow.png";
import DeleteCard from "../../../Components/Cards/DeleteCard/DeleteCard";
import FeesForm from "../../../Components/Forms/Fees/Fees_Form";
import { useSearch } from "../../../context/SearchContext";
import api from "../../../utils/api";
import { getLastDate } from "../../../utils/dateUtils";
import "./Setup.css";
import moment from "moment";

const Setup = () => {
  const { search } = useSearch();
  const [display1, setDisplay1] = useState(0);
  const [datas, setDatas] = useState([]);
  const [editData, setEditData] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [del, setDel] = useState(0);
  const [delId, setDelId] = useState(0);
  const [sortBy, setSortBy] = useState("asc");
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });

  const handleClick1 = () => {
    setDisplay1(1);
  };

  useEffect(() => {
    let sortedData;
    if (sortBy == "asc") {
      sortedData = datas?.sort(function (a, b) {
        a = getLastDate(a.late_date).split("-");
        b = getLastDate(b.late_date).split("-");
        return a[0] - b[0] || a[1] - b[1] || a[2] - b[2];
      });
      setDatas(sortedData);
    } else {
      sortedData = datas?.sort(function (a, b) {
        a = getLastDate(a.late_date).split("-");
        b = getLastDate(b.late_date).split("-");
        return b[0] - a[0] || b[1] - a[1] || b[2] - a[2];
      });
      setDatas(sortedData);
    }
  }, [sortBy, datas]);

  const fetchData = async () => {
    try {
      const response = await api.get(`/feessetup?search=${search}&page=${pagination.page}&limit=${pagination.limit}`);
      setDatas(response.data.data);
      setPagination(response.data.pagination);
    } catch (error) {
      toast.error("Failed to fetch fees setup data!");
    }
  };

  useEffect(() => {
    fetchData();
  }, [search, pagination.page, pagination.limit]);

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({
      ...prev,
      page: newPage,
    }));
  };

  const handleDelete = async (id) => {
    await api.delete(`/feessetup/${id}`);
    toast.success("Fees setup deleted successfully");
    setDel(0);
    setDelId(0);
    fetchData();
  };

  return (
    <div className="setup">
      {display1 ? (
        <FeesForm
          onSuccess={fetchData}
          setDisp={() => {
            setDisplay1(0);
          }}
          data={editData}
          isEdit={isEdit}
          setEdit={() => {
            setIsEdit(false);
          }}
        />
      ) : null}
      {del ? (
        <DeleteCard
          del={() => {
            handleDelete(delId);
          }}
          close={() => {
            setDel(0);
          }}
        />
      ) : null}
      <div className="setup__top">
        <div className="setup__top_button_left_most">
          <button type="button" className="setup__top_button_setup setup__top_button_go" onClick={handleClick1}>
            Add Fees setup
          </button>
        </div>
      </div>
      <div className="setup__middle">
        <table>
          <thead>
            <tr className="setup__middle_tr">
              <th className="setup__middle_th">Section</th>
              <th className="setup__middle_th">Class</th>
              <th className="setup__middle_th">Months</th>
              <th className="report__middle_th">Academic Year</th>
              <th className="setup__middle_th">
                Late Fees Date{" "}
                {sortBy == "asc" ? (
                  <img
                    src={uparrow}
                    alt="uparrow"
                    style={{
                      height: 20,
                      width: 20,
                      marginBottom: -5,
                      marginLeft: 10,
                    }}
                    onClick={() => {
                      setSortBy("desc");
                    }}
                  />
                ) : (
                  <img
                    src={downarrow}
                    alt="downarrow"
                    style={{
                      height: 20,
                      width: 20,
                      marginBottom: -5,
                      marginLeft: 10,
                    }}
                    onClick={() => {
                      setSortBy("asc");
                    }}
                  />
                )}
              </th>
              <th className="setup__middle_th">Total Fee</th>
              <th className="setup__middle_th"></th>
            </tr>
          </thead>
          <tbody>
            {datas &&
              datas.map((data, index) => {
                return (
                  <tr className="setup__middle_tr scroll" key={"0" + index}>
                    <td className="setup__middle_td">{data.section || "-"}</td>
                    <td className="setup__middle_td">{data.class || "-"}</td>
                    <th className="setup__middle_td">{data.months && data.months.length > 0 ? data.months.map((mon) => mon?.toUpperCase().substring(0, 3)).join(", ") : "-"}</th>
                    <td className="setup__middle_td">{data?.academic_year_start ? new Date(data?.academic_year_start).getFullYear() + "-" + new Date(data?.academic_year_end).getFullYear() : "-"}</td>

                    <td className="setup__middle_td">{data.late_date ? moment(data.late_date).format("DD-MM-YYYY") : "-"}</td>

                    <td className="setup__middle_td">{data.total ?? "-"}</td>

                    <td className="setup__middle_td">
                      <button
                        type="button"
                        onClick={() => {
                          setDel(1);
                          setDelId(data.id);
                        }}
                        className="setup__middle_td_delete"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      {/* Pagination Controls */}
      <div
        className="pagination-controls"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "20px",
          gap: "10px",
        }}
      >
        <button
          onClick={() => handlePageChange(pagination.page - 1)}
          disabled={pagination.page === 1}
          style={{
            padding: "5px 10px",
            cursor: pagination.page === 1 ? "not-allowed" : "pointer",
            opacity: pagination.page === 1 ? 0.5 : 1,
          }}
        >
          Previous
        </button>

        <span>
          Page {pagination.page} of {pagination.totalPages}
        </span>

        <button
          onClick={() => handlePageChange(pagination.page + 1)}
          disabled={pagination.page === pagination.totalPages}
          style={{
            padding: "5px 10px",
            cursor: pagination.page === pagination.totalPages ? "not-allowed" : "pointer",
            opacity: pagination.page === pagination.totalPages ? 0.5 : 1,
          }}
        >
          Next
        </button>

        <div style={{ marginLeft: "20px" }}>
          <label htmlFor="limit-select" style={{ marginRight: "10px" }}>
            Items per page:
          </label>
          <select
            id="limit-select"
            value={pagination.limit}
            onChange={(e) => {
              setPagination((prev) => ({
                ...prev,
                limit: Number(e.target.value),
                page: 1, // Reset to first page when changing limit
              }));
            }}
            style={{
              padding: "5px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              backgroundColor: "rgb(239,239,239)",
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default Setup;
